/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { DeliveryStatus } from './delivery-status';
// May contain unused imports in some cases
// @ts-ignore
import type { OrderItem } from './order-item';
// May contain unused imports in some cases
// @ts-ignore
import type { SafeUser } from './safe-user';

/**
 * 
 * @export
 * @interface OrderAdmin
 */
export interface OrderAdmin {
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'clientId': number;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'status': OrderAdminStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'phone': string;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'lon': number;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'address': string;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'deliveryAmount': number;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'bonusAmount': number;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'discountAmount': number;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'deliveryMode': OrderAdminDeliveryModeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'deliveryType': OrderAdminDeliveryTypeEnum;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof OrderAdmin
     */
    'items': Array<OrderItem>;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'purchasePrice': number;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'discountId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'cdekTariffCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'officeCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'cityCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'cdekTrackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'paymentId'?: string;
    /**
     * 
     * @type {DeliveryStatus}
     * @memberof OrderAdmin
     */
    'deliveryStatus'?: DeliveryStatus;
    /**
     * 
     * @type {number}
     * @memberof OrderAdmin
     */
    'deliveryDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderAdmin
     */
    'comment'?: string;
    /**
     * 
     * @type {SafeUser}
     * @memberof OrderAdmin
     */
    'client'?: SafeUser;
}

export const OrderAdminStatusEnum = {
    Created: 'CREATED',
    Pending: 'PENDING',
    Discard: 'DISCARD',
    Success: 'SUCCESS'
} as const;

export type OrderAdminStatusEnum = typeof OrderAdminStatusEnum[keyof typeof OrderAdminStatusEnum];
export const OrderAdminDeliveryModeEnum = {
    Door: 'DOOR',
    Office: 'OFFICE'
} as const;

export type OrderAdminDeliveryModeEnum = typeof OrderAdminDeliveryModeEnum[keyof typeof OrderAdminDeliveryModeEnum];
export const OrderAdminDeliveryTypeEnum = {
    Default: 'DEFAULT',
    Airplane: 'AIRPLANE'
} as const;

export type OrderAdminDeliveryTypeEnum = typeof OrderAdminDeliveryTypeEnum[keyof typeof OrderAdminDeliveryTypeEnum];


